export let Action;
(function (_Action) {
  let Type = /*#__PURE__*/function (Type) {
    Type["AdvanceScreen"] = "ADVANCE_SCREEN";
    Type["BackButtonClick"] = "BACK_BUTTON_CLICK_KYB";
    Type["BrowserHistoryChange"] = "BROWSER_HISTORY_CHANGE";
    Type["BusinessManagementScreenUpdate"] = "BUSINESS_MANAGEMENT_SCREEN_UPDATE";
    Type["BusinessTypeScreenUpdate"] = "BUSINESS_TYPE_SCREEN_UPDATE";
    Type["ControllingIndividualsScreenUpdate"] = "CONTROLLING_INDIVIDUALS_SCREEN_UPDATE";
    Type["UserChangeEntityType"] = "USER_CHANGE_ENTITY_TYPE";
    Type["EntityTypeScreenUpdate"] = "ENTITY_TYPE_SCREEN_UPDATE";
    Type["Initialize"] = "ONBOARDING-KYB/INITIALIZE";
    Type["ReturnToFlow"] = "RETURN_TO_FLOW";
    Type["ToggleLoading"] = "TOGGLE_LOADING";
    return Type;
  }({});
  _Action.Type = Type;
})(Action || (Action = {}));
export const advanceScreenAction = () => ({
  type: Action.Type.AdvanceScreen
});
export const backButtonClickAction = () => ({
  type: Action.Type.BackButtonClick
});
export const browserHistoryChangeAction = routeName => ({
  type: Action.Type.BrowserHistoryChange,
  routeName
});
export const businessManagementScreenUpdateAction = data => ({
  type: Action.Type.BusinessManagementScreenUpdate,
  data
});
export const businessTypeScreenUpdateAction = data => ({
  type: Action.Type.BusinessTypeScreenUpdate,
  data
});
export const controllingIndividualsScreenUpdateAction = data => ({
  type: Action.Type.ControllingIndividualsScreenUpdate,
  data
});
export const userChangeEntityTypeAction = entityType => ({
  type: Action.Type.UserChangeEntityType,
  entityType
});
export const entityTypeScreenUpdateAction = data => ({
  type: Action.Type.EntityTypeScreenUpdate,
  data
});
export const initializeAction = ({
  businessName,
  taxIdSerialNumber,
  entityType,
  existingIndividuals = [],
  reviewBusinessAddress = false
}) => ({
  type: Action.Type.Initialize,
  businessName,
  taxIdSerialNumber,
  entityType,
  existingIndividuals,
  reviewBusinessAddress
});
export const returnToFlowAction = () => ({
  type: Action.Type.ReturnToFlow
});
export const toggleLoadingAction = value => ({
  type: Action.Type.ToggleLoading,
  value
});